// extracted by mini-css-extract-plugin
export default {"assetScreen":"p4fl6","spinner":"mIeLy"};